import { useAuth } from '@core/gameengine/state/auth';

function resolveLoggedInUserId(): string | undefined {
  const user = useAuth.getState().user;
  if (!user) {
    return undefined;
  }

  return user.nickname?.trim() || user.username?.trim() || undefined;
}

function resolveLoggedInUserName(): string | undefined {
  const user = useAuth.getState().user;
  if (!user) {
    return undefined;
  }

  return user?.playerId?.trim() || user.nickname?.trim() || undefined;
}

export function syncNewRelicUserId(): void {
  const userId = resolveLoggedInUserId();
  if (!userId) {
    return;
  }

  window.newrelic?.setCustomAttribute('userId', userId);
  window.newrelic?.setCustomAttribute(
    'userName',
    resolveLoggedInUserName() ?? ''
  );
}

/** Keep New Relic userId aligned with auth (login, restore, demo, logout). */
export function initNewRelicUserSync(): void {
  syncNewRelicUserId();

  useAuth.subscribe((state, prev) => {
    const userId = state.user?.playerId ?? state.user?.username;
    const prevUserId = prev.user?.playerId ?? prev.user?.username;
    if (userId !== prevUserId) {
      syncNewRelicUserId();
    }
  });
}
